// extracted by mini-css-extract-plugin
export var container = "_8h-0";
export var error = "_8h-9";
export var label = "_8h-5";
export var light = "_8h-6";
export var md = "_8h-3";
export var sm = "_8h-2";
export var thin = "_8h-8";
export var thinBold = "_8h-7";
export var vertical = "_8h-4";
export var xs = "_8h-1";